// -----------------------------------------------------------------------------
// 4) src/components/CommentForm.jsx
// -----------------------------------------------------------------------------
import React from "react";
import { api } from "../lib/api";

export function CommentForm({ target, objectId, onPosted }) {
  const [text, setText] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.postJson("/engagement/comments/", { target, object_id: objectId, text });
      setText("");
      onPosted && onPosted();
    } catch (e) {
      console.warn("comment post failed", e);
      alert(e.message || "Unable to post comment");
    } finally { setBusy(false); }
  }

  return (
    <form onSubmit={submit} style={{ display: "grid", gap: 8 }}>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3}
        placeholder="Write a comment…"
        style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 10 }} />
      <div>
        <button type="submit" disabled={busy || !text.trim()} style={{
          height: 34, padding: "0 12px", borderRadius: 8, border: "1px solid #e5e7eb",
          background: "#111827", color: "#fff", cursor: "pointer"
        }}>Post</button>
      </div>
    </form>
  );
}

